export default __webpack_public_path__ + "static/media/icon-user-active.feb482fc.svg";